 //export const API_BASE_URL = "https://newsapp.aasmo.in/api/v1/superadmin";

//export const API_BASE_URL = "https://117pw42t-8004.inc1.devtunnels.ms/api/v1/superadmin";
//export const API_BASE_URL = "https://backend.emsindia.com/api/v1/superadmin";
// export const API_BASE_URL = "https://newsapp.aasmo.in/api/v1/superadmin"; 
export const API_BASE_URL = " https://backend.xpressnews.in/api/v1/superadmin";
export const API_ENDPOINT = {
  ADMIN_REGISTER: `${API_BASE_URL}/admins/register`,
  GET_ALL_ADMINS: `${API_BASE_URL}/admins`,
  UPDATE_ADMIN_PERMISSIONS: `${API_BASE_URL}/admins`, // id baad me append hoga
  CREATE_ADMIN:`${API_BASE_URL}/create-admin`, 
};
